<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-dark-600">
    <div class="max-w-md w-full px-6 py-8 bg-white dark:bg-dark-800 rounded-lg shadow-md text-center">
      <div class="text-red-600 mb-4">
        <svg class="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      </div>
      <h1 class="text-2xl font-bold text-gray-900 dark:text-dark-100 mb-4">Access Denied</h1>
      <p class="text-gray-600 dark:text-dark-400 mb-6">Sorry, you don't have permission to access this page.</p>
      <div class="space-y-4">
        <router-link 
          to="/" 
          class="block w-full px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          Return to Dashboard
        </router-link>
        <button 
          @click="goBack" 
          class="block w-full px-4 py-2 text-sm font-medium text-blue-600 bg-white dark:bg-dark-800 border border-blue-600 rounded-md hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          Go Back
        </button>
        <button 
          @click="handleLogout" 
          class="block w-full px-4 py-2 text-sm font-medium text-red-600 bg-white dark:bg-dark-800 border border-red-600 rounded-md hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
        >
          Logout
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { useAuthStore } from '../stores/auth';

const router = useRouter();
const authStore = useAuthStore();

const goBack = () => {
  router.back();
};

const handleLogout = () => {
  authStore.logout();
  router.push('/auth/login');
};
</script> 






